<template>
	<div class="d-flex flex-row align-content-center px-0">
		<botao-tooltip
			icone="mdi-pencil"
			cor="grey"
			texto="Editar"
			@click="abrirModalEditar"
			v-az-auth="permissoes.modeloDocumentoEditar"
		></botao-tooltip>
		<botao-tooltip
			icone="mdi-file-search-outline"
			cor="grey"
			v-az-auth="permissoes.modeloDocumentoVisualizarConteudo"
			texto="Visualizar"
			@click="visualizar"
		></botao-tooltip>
		<botao-tooltip
			icone="mdi-login"
			cor="grey"
			texto="Redigir"
			@click="redigir"
			v-az-auth="permissoes.modeloDocumentoRedigir"
		></botao-tooltip>
		<botao-tooltip
			icone="mdi-delete"
			cor="grey"
			texto="Excluir"
			@click="abrirModalExcluir"
			v-az-auth="permissoes.modeloDocumentoExcluir"
		></botao-tooltip>
	</div>
</template>

<script>
import documentoMixin from '@/views/mixins/documento'
import { actionTypes } from '@/core/constants'

export default {
	name: 'modelo-documento-listagem-botoes-acoes',
	mixins: [documentoMixin],
	props: {
		idModelo: {
			type: Number,
			required: true,
		},
	},
	methods: {
		async visualizar() {
			const editor = await this.$store.dispatch(
				actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.VISUALIZAR_MODELOS_DOCUMENTOS,
				this.idModelo,
			)
			this.redirecionarPara(editor.urlVisualizar)
		},
		async redigir() {
			const editor = await this.$store.dispatch(
				actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.REDIGIR_MODELOS_DOCUMENTOS,
				this.idModelo,
			)
			this.redirecionarPara(editor.urlRedigir)
		},
		abrirModalEditar() {
			this.$emit('abrir-modal-editar')
		},
		async abrirModalExcluir() {
			this.$emit('abrir-modal-excluir')
		},
	},
}
</script>

<style scoped></style>
